export class WebFsError extends Error {
    devDetails;
    constructor(message, devDetails) {
        super(message);
        this.devDetails = devDetails;
    }
}
export class InternalError extends WebFsError {
}
export class InvalidArgumentError extends WebFsError {
}
export class InvalidPermissionsError extends WebFsError {
}
export class SettingValidationError extends InvalidArgumentError {
}
export class EventCursorExpiredError extends InvalidArgumentError {
}
export class EventStreamUnsupportedError extends WebFsError {
}
export class InvalidKeyError extends WebFsError {
}
export class InvalidStateError extends WebFsError {
}
export class EventSchemaUnsupportedError extends InvalidStateError {
}
export class IoError extends WebFsError {
}
export class UnauthorizedError extends WebFsError {
}
export class TerminateClientError extends WebFsError {
}
export class ConflictError extends WebFsError {
}
export class TimeoutError extends WebFsError {
}
export class InvalidPathError extends WebFsError {
}
export class InvalidFileIdError extends WebFsError {
}
export class UserError extends WebFsError {
}
export class CryptoError extends WebFsError {
}
export class CompressionError extends WebFsError {
}
export class AuthorizationError extends WebFsError {
}
export class ClientVersionError extends WebFsError {
}
export class ConnectionError extends WebFsError {
}
export class LockingError extends WebFsError {
}
export class DirExistsError extends WebFsError {
}
export class FileExistsError extends WebFsError {
}
export class NotDirError extends WebFsError {
}
export class IsDirError extends WebFsError {
}
export class NotLinkError extends WebFsError {
}
export class ExternalFileTypeMismatchError extends WebFsError {
}
export class FileSizeMismatchError extends WebFsError {
}
export class NotEnoughDiskSpaceError extends WebFsError {
}
export class NotImplementedError extends WebFsError {
    constructor(details) {
        super('Not implemented!', details);
    }
}
export class FilespaceEpochError extends WebFsError {
    constructor(message) {
        super('Detected an inconsistent local file index caused by an out of date local filesystem(epoch error). ' +
            'To restore Filespace access, any local changes will be lost and you will be reconnected to the Filespace. ' +
            (message ? ` Reason: ${message}` : ''));
    }
}
export class SnapshotError extends WebFsError {
}
export class UnknownError extends WebFsError {
}
export class BufferEmptyError extends WebFsError {
    constructor(message, devDetails) {
        super(message ? message : 'Buffer is empty', devDetails);
    }
}
